"use client";

import React from "react";
import { BeautyPieIcon } from "@shared/ui.icons";
import { logoContainer, logoImage } from "./FooterLogo.css";
import { Link } from "@shared/ui.primitives";

export const FooterLogo: React.FC = () => {
  return (
    <div className={logoContainer}>
      <Link href="/" dataTestId="footer-logo" aria-label="Logo">
        <BeautyPieIcon className={logoImage} />
      </Link>
    </div>
  );
};
